module.exports = __webpack_public_path__ + "img/splash.bc16524e.png";